<template>
    <div class="organization-list">
        <vx-card>
            <div class="header mb-4 flex justify-between items-center">
                <h2>{{ $t('labels.organizations') }}</h2>
                <vs-button :to="{ name: 'AddOrganization' }" color="primary" icon="icon-plus" type="filled"
                    icon-pack="feather" class="float-right btn-add sm: mb-6 md:m-0">
                    {{ $t('labels.add_organization') }}
                </vs-button>
            </div>
            <vs-table :data="organizations" class="permission">
                <template slot="thead">
                    <vs-th class="col-md-3">{{ $t("labels.number") }}</vs-th>
                    <vs-th class="col-md-6">{{ $t("labels.organisation_name") }}</vs-th>
                    <vs-th class="col-md-3">{{ $t("labels.action") }}</vs-th>
                </template>

                <template slot-scope="{ data }">
                    <vs-tr :data="org" :key="index" v-for="(org, index) in data">
                        <vs-td>{{ org.id }}</vs-td>
                        <vs-td>{{ org.name }}</vs-td>
                        <vs-td width="135">
                            <div class="flex">
                                <vs-button type="flat" :title="$t('labels.edit')" size="large" icon-pack="feather"
                                    icon="icon-edit" color="warning" class="mr-2"
                                    v-if="checkPermission('organizations', 'modify')"
                                    @click="$router.push({ name: 'EditOrganization', params: { id: org.id } })" />
                                <vs-button @click="confirmDelete(org.id)" type="flat" :title="$t('labels.delete')"
                                    size="large" icon-pack="feather" icon="icon-trash-2" color="danger"
                                    v-if="checkPermission('organizations', 'delete')" />
                            </div>
                        </vs-td>
                    </vs-tr>
                </template>
            </vs-table>
            <div class="mt-6">
                <vs-pagination color="dark" :total="totalPage" v-model="currentx" class="mb-1"></vs-pagination>
            </div>
        </vx-card>
    </div>
</template>

<script>
export default {
    data() {
        return {
            organizations: [],
            currentx: 1,
            perPage: 10, // Number of records per page
            totalCount: 0, // Total records count from API
        };
    },
    computed: {
        totalPage() {
            return Math.ceil(this.totalCount / this.perPage);
        },
    },
    mounted() {
        this.fetchOrganizations();
    },
    methods: {
        async fetchOrganizations() {
            let response = await this.getHTTPPostResponse('/organizations/list');
            if (response) {
                this.organizations = response.data.organizations;
                this.totalCount = response.data.count;
            }
        },
        confirmDelete(id) {
            this.$vs.dialog({
                type: 'confirm',
                color: 'danger',
                title: this.$t('labels.delete'),
                text: this.$t('strings.delete_confirm'),
                acceptText: this.$t('labels.delete'),
                cancelText: this.$t('labels.cancel'),
                accept: () => {
                    this.deleteOrganization(id);
                }
            });
        },
        async deleteOrganization(id) {
            try {
                const response = await this.getHTTPPostResponse(`/organizations/delete/`, { id });

                if (response && response.status === "200") {
                    this.$vs.notify({
                        title: this.$t('labels.success'),
                        text: this.$t('strings.organization_deleted'),
                        color: 'success',
                        position: 'top-right'
                    });

                    this.fetchOrganizations();  // or use router.push if you prefer navigation
                }
            } catch (error) {
                this.$vs.notify({
                    title: this.$t('labels.error'),
                    text: this.$t('messages.delete_failed'),
                    color: 'danger',
                    position: 'top-right'
                });
            }
        },
    }
};
</script>
